import { axiosBasic, axiosBearer } from "../config/axios-common";
import ProfssionalTeam from "../models/ProfssionalTeam";

const postInsertOrUpdateProfssionalTeam = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/professionalTeam/insertOrUpdateProfessionalTeam?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetProfssionalTeamFromTasy = async (requestId: string): Promise<ProfssionalTeam[]> => {

    const response = await axiosBearer.post(`/sam/v1/professionalTeam/CreateAndGetProfessionalTeamFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<ProfssionalTeam>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = ProfssionalTeam.NewInstance();

                item.Id = row.id;
                item.TeamName = row.teamName;
                item.BossName = row.bossName;
                item.TeamTasyCode = row.teamTasyCode;
                item.OccupationTasyCode = row.occupationTasyCode;
                item.OccupationName = row.occupationName;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};




const exportedObject = {
    postInsertOrUpdateProfssionalTeam,
    CreateAndGetProfssionalTeamFromTasy
};


export default exportedObject